var module_name = "service.clinic";
const $inject = ["$http"];

class ClinicService {
  constructor($http) {
    this.$http = $http;
  }

  api_key(clinic_id, handle_success, handle_error) {
    return this.$http
      .post(`/admin/clinic/${clinic_id}/generate-api-key`)
      .then(handle_success, handle_error);
  }
}

ClinicService.$inject = $inject;

export default angular.module(module_name, [])
  .service("ClinicService", ClinicService)
  .name;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/services/clinic.service.js
 **/